import sectorHealthEvents from './events/sectorHealthEvents'

const events =
{
    sectorHealthEvents
};

export default events ;